webpackJsonp([0],{

/***/ "28OM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_799e61ee_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BookReadingSymtem_vue__ = __webpack_require__("dKxR");
function injectStyle (ssrContext) {
  __webpack_require__("rfg/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-799e61ee"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_799e61ee_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BookReadingSymtem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2ghL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"module-cont module-features"},[_c('div',{staticClass:"title-cont"},[_c('h1',[_c('span',{staticClass:"fzlty-zc"},[_vm._v("KaDa")]),_vm._v("阅读理念")]),_vm._v(" "),_c('p',[_vm._v("KaDa阅读致力于为3-12岁儿童搭建“金字塔”三层阅读体系,解决孩子不爱阅读、阅读量不够、不会阅读的问题，建立其丰富的知识格局、促进情感能力提升、培养人文素养，以阅读滋养儿童成长。")])]),_vm._v(" "),_c('img',{attrs:{"src":"//cdn.hhdd.com/frontend/as/i/238dd083-215c-58af-90a0-d5eb1454cf58.png","alt":""}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3FXf":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("9RS9");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("7da83cfe", content, true, {});

/***/ }),

/***/ "3Kq5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"connect-us-cont",style:(_vm.blueBg ? 'background: linear-gradient( 310deg, #3398FF 0%, #61C7FF 100%);' : (!_vm.whiteBg ? 'background-color: #f6f8fb;' : ''))},[_vm._m(0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contact-us light"},[_c('h2',{staticClass:"mb-10 fz-18"},[_vm._v("联系我们")]),_vm._v(" "),_c('p',[_vm._v("电话：400-055-2660")]),_vm._v(" "),_c('p',[_vm._v("微信：kadastory01")]),_vm._v(" "),_c('p',[_vm._v("邮箱：service@hhdd.com")]),_vm._v(" "),_c('h2',{staticClass:"mt-10 mb-10 fz-18"},[_vm._v("品牌、版权、商务合作")]),_vm._v(" "),_c('p',[_vm._v("向老师 xiangtiantian0557@hhdd.com")]),_vm._v(" "),_c('p',[_vm._v("杭州红花朵朵网络技术有限公司")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "74q4":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("MBS+");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("bf98ad6c", content, true, {});

/***/ }),

/***/ "7DzZ":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(true);
// imports


// module
exports.push([module.i, ".module-app .home-header[data-v-bc232558]{position:relative}.module-app .home-header .btn[data-v-bc232558]{position:absolute;left:.53333rem;bottom:4.85333rem;width:4rem;background:transparent;border:none}", "", {"version":3,"sources":["/Users/randy/kada-official-web/public/mobile/src/views/home/QRAndBg.vue"],"names":[],"mappings":"AACA,0CACE,iBAAmB,CACpB,AACD,+CACE,kBAAmB,AACnB,eAAiB,AACjB,kBAAmB,AACnB,WAAY,AACZ,uBAAwB,AACxB,WAAa,CACd","file":"QRAndBg.vue","sourcesContent":["\n.module-app .home-header[data-v-bc232558] {\n  position: relative;\n}\n.module-app .home-header .btn[data-v-bc232558] {\n  position: absolute;\n  left: 0.53333rem;\n  bottom: 4.85333rem;\n  width: 4rem;\n  background: transparent;\n  border: none;\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ "7S72":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BooksDesc_vue__ = __webpack_require__("Ykqc");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_56d73d1a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BooksDesc_vue__ = __webpack_require__("AWsT");
function injectStyle (ssrContext) {
  __webpack_require__("pCi2")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-56d73d1a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BooksDesc_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_56d73d1a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BooksDesc_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "83Cv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        imgSrc: {
            type: String,
            default: '//cdn.hhdd.com/frontend/as/i/603ae87e-50b7-569d-9137-ab45bd5b97c9.png'
        },
        whiteBg: {
            type: Boolean,
            default: false
        }
    },
    components: {},
    data: function data() {
        return {
            firstLineData: [{ count: '10000+', desc: '互动绘本' }, { count: '20000+', desc: '有声故事' }, { count: '15000+', desc: '知识轻课' }, { count: '4000+', desc: '经典图书' }],
            secondLineData: [{ count: '300+', desc: '内容机构合作' }, { count: '600+', desc: '主题内容覆盖' }, { count: '116+', desc: '童书大奖覆盖' }, { count: '120+', desc: '全球名家荟萃' }]
        };
    }
});

/***/ }),

/***/ "9RS9":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(true);
// imports


// module
exports.push([module.i, ".page-home{background:#fff}@media (max-width:320px){.connect-us-cont .contact-copyright,.connect-us-cont .contact-us{font-size:.32rem}.connect-us-cont .contact-us{padding-left:.37333rem}}", "", {"version":3,"sources":["/Users/randy/kada-official-web/public/mobile/src/views/home/home.vue"],"names":[],"mappings":"AACA,WACE,eAAiB,CAClB,AAED,yBACA,iEAEI,gBAAmB,CACtB,AACD,6BACI,sBAAyB,CAC5B,CACA","file":"home.vue","sourcesContent":["\n.page-home {\n  background: #fff;\n}\n/* 添加媒体查询，针对iphone5以下小屏设备样式 */\n@media (max-width: 320px) {\n.connect-us-cont .contact-us,\n  .connect-us-cont .contact-copyright {\n    font-size: 0.32rem;\n}\n.connect-us-cont .contact-us {\n    padding-left: 0.37333rem;\n}\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ "AWsT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"module-cont module-books"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"icon-list-cont"},_vm._l((_vm.iconList),function(item,index){return _c('div',{key:index,staticClass:"icon-item"},[_c('img',{attrs:{"src":item.imgUrl,"alt":""}}),_vm._v(" "),_c('p',{staticClass:"icon-desc",domProps:{"innerHTML":_vm._s(item.desc)}})])}),0),_vm._v(" "),_c('img',{staticClass:"mobile-icon",attrs:{"src":_vm.mobileImg,"alt":""}})])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-cont"},[_c('div',{staticClass:"title-style"},[_c('span',{staticClass:"fzlty-zc"},[_vm._v("KaDa")]),_vm._v("图画阅读馆-绘本")]),_vm._v(" "),_c('div',{staticClass:"desc-style"},[_vm._v("10000+正版绘本，让孩子阅见世界")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "B5rl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"module-cont module-app"},[_c('header',{staticClass:"home-header"},[_c('img',{attrs:{"src":"//cdn.hhdd.com/frontend/as/i/748413ef-3bfb-5b5b-b024-33997cd70378.png","alt":"header_banner"}}),_vm._v(" "),_c('i',{staticClass:"btn",on:{"click":_vm.downApp}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Ci0F":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("D/3P");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("0b255622", content, true, {});

/***/ }),

/***/ "D/3P":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(true);
// imports


// module
exports.push([module.i, ".module-harvest .title-cont[data-v-11b5351e]{padding-top:1.04rem;text-align:center}.module-harvest .title-cont h1[data-v-11b5351e]{font-size:.53333rem;font-weight:600;color:#3f3f3f;height:.74666rem;line-height:.74666rem;margin-bottom:.16rem}.module-harvest .title-cont p[data-v-11b5351e]{font-size:.32rem;color:#666;height:.45333rem;line-height:.45333rem}.module-harvest .img-cont[data-v-11b5351e]{padding:.8rem .53333rem 0}.module-harvest .img-cont img[data-v-11b5351e]{margin-bottom:.53333rem}.module-harvest .img-cont img[data-v-11b5351e]:last-child{margin-bottom:0}.module-harvest .parttner-channel-list[data-v-11b5351e]{display:-webkit-box;display:-webkit-flex;display:flex;-webkit-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-pack:justify;-webkit-justify-content:space-between;-moz-justify-content:space-between;justify-content:space-between;margin-top:.53333rem}.module-harvest .parttner-channel-list .parttner-channel-item[data-v-11b5351e]{margin-bottom:.26666rem}.module-harvest .parttner-channel-list .parttner-channel-item img[data-v-11b5351e]{width:2.05333rem;height:2.05333rem}.module-harvest .section-harvest[data-v-11b5351e]{background:#f2f9ff;padding-bottom:1.06666rem}.module-harvest .section-partner[data-v-11b5351e]{padding:0 .42666rem}.module-harvest .section-partner .title-cont[data-v-11b5351e]{padding-top:.8rem}", "", {"version":3,"sources":["/Users/randy/kada-official-web/public/mobile/src/views/home/CollectAndPartner.vue"],"names":[],"mappings":"AACA,6CACE,oBAAqB,AACrB,iBAAmB,CACpB,AACD,gDACE,oBAAsB,AACtB,gBAAiB,AACjB,cAAe,AACf,iBAAmB,AACnB,sBAAwB,AACxB,oBAAuB,CACxB,AACD,+CACE,iBAAmB,AACnB,WAAY,AACZ,iBAAmB,AACnB,qBAAwB,CACzB,AACD,2CACE,yBAAgC,CACjC,AACD,+CACE,uBAA0B,CAC3B,AACD,0DACE,eAAoB,CACrB,AACD,wDACE,oBAAqB,AACrB,qBAAsB,AACtB,aAAc,AACd,uBAAwB,AACxB,eAAgB,AAChB,yBAA0B,AAC1B,sCAAuC,AACvC,mCAAoC,AACpC,8BAA+B,AAC/B,oBAAuB,CACxB,AACD,+EACE,uBAA0B,CAC3B,AACD,mFACE,iBAAkB,AAClB,iBAAmB,CACpB,AACD,kDACE,mBAAoB,AACpB,yBAA2B,CAC5B,AACD,kDACE,mBAAsB,CACvB,AACD,8DACE,iBAAoB,CACrB","file":"CollectAndPartner.vue","sourcesContent":["\n.module-harvest .title-cont[data-v-11b5351e] {\n  padding-top: 1.04rem;\n  text-align: center;\n}\n.module-harvest .title-cont h1[data-v-11b5351e] {\n  font-size: 0.53333rem;\n  font-weight: 600;\n  color: #3f3f3f;\n  height: 0.74666rem;\n  line-height: 0.74666rem;\n  margin-bottom: 0.16rem;\n}\n.module-harvest .title-cont p[data-v-11b5351e] {\n  font-size: 0.32rem;\n  color: #666;\n  height: 0.45333rem;\n  line-height: 0.45333rem;\n}\n.module-harvest .img-cont[data-v-11b5351e] {\n  padding: 0.8rem 0.53333rem 0rem;\n}\n.module-harvest .img-cont img[data-v-11b5351e] {\n  margin-bottom: 0.53333rem;\n}\n.module-harvest .img-cont img[data-v-11b5351e]:last-child {\n  margin-bottom: 0rem;\n}\n.module-harvest .parttner-channel-list[data-v-11b5351e] {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: flex;\n  -webkit-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -webkit-box-pack: justify;\n  -webkit-justify-content: space-between;\n  -moz-justify-content: space-between;\n  justify-content: space-between;\n  margin-top: 0.53333rem;\n}\n.module-harvest .parttner-channel-list .parttner-channel-item[data-v-11b5351e] {\n  margin-bottom: 0.26666rem;\n}\n.module-harvest .parttner-channel-list .parttner-channel-item img[data-v-11b5351e] {\n  width: 2.05333rem;\n  height: 2.05333rem;\n}\n.module-harvest .section-harvest[data-v-11b5351e] {\n  background: #f2f9ff;\n  padding-bottom: 1.06666rem;\n}\n.module-harvest .section-partner[data-v-11b5351e] {\n  padding: 0 0.42666rem;\n}\n.module-harvest .section-partner .title-cont[data-v-11b5351e] {\n  padding-top: 0.8rem;\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ "DODS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"module-cont module-statistic",style:(_vm.whiteBg ? 'background: white': '')},[_c('img',{attrs:{"src":_vm.imgSrc,"alt":"","srcset":""}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "EeHo":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("NktS");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("5ca0a056", content, true, {});

/***/ }),

/***/ "Eq9c":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("W3Lf");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("3d904047", content, true, {});

/***/ }),

/***/ "K/qR":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("lOWy");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("ba42e284", content, true, {});

/***/ }),

/***/ "L3Ll":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3dabd3ad_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BookAnServiceDesc_vue__ = __webpack_require__("2ghL");
function injectStyle (ssrContext) {
  __webpack_require__("f2c8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3dabd3ad"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3dabd3ad_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BookAnServiceDesc_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MBS+":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(true);
// imports


// module
exports.push([module.i, ".module-statistic[data-v-3fee451e]{padding-top:.96rem;background-color:#f6f8fb}", "", {"version":3,"sources":["/Users/randy/kada-official-web/public/mobile/src/views/home/BookNumberDesc.vue"],"names":[],"mappings":"AACA,mCACE,mBAAqB,AACrB,wBAA0B,CAC3B","file":"BookNumberDesc.vue","sourcesContent":["\n.module-statistic[data-v-3fee451e] {\n  padding-top: 0.96rem;\n  background-color: #f6f8fb;\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ "MY0F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    components: {},
    data: function data() {
        return {};
    },

    methods: {
        downApp: function downApp() {
            if (device.ios || device.android) {
                // this.$uweb.trackEvent('events', "official-download", "mobile");
                setTimeout(function () {
                    location.href = "http://www.hhdd.com/app";
                }, 100);
            }
        }
    }
});

/***/ }),

/***/ "Malx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        blueBg: {
            type: Boolean,
            default: false
        },
        whiteBg: {
            type: Boolean,
            default: false
        }
    }
});

/***/ }),

/***/ "NktS":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(true);
// imports


// module
exports.push([module.i, ".module-story[data-v-43060691]{background:#f6f8fb;position:relative;padding:1.17333rem .42666rem}.module-story .title-style[data-v-43060691]{text-align:center;color:#3f3f3f;font-size:.48rem;font-weight:600}.module-story .desc-style[data-v-43060691]{text-align:center;margin-top:.16rem;color:#3f3f3f;font-size:.32rem}.module-story .icon-list-cont[data-v-43060691]{margin-top:.53333rem;display:-webkit-box;display:-webkit-flex;display:flex;-webkit-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-pack:space-around;-webkit-justify-content:space-around;-moz-justify-content:space-around;justify-content:space-around}.module-story .icon-list-cont .icon-item[data-v-43060691]{width:48%;border-radius:.53333rem;background:#fff;display:-webkit-box;display:-webkit-flex;display:flex;-webkit-box-align:center;-webkit-align-items:center;-moz-align-items:center;align-items:center;color:#666;font-size:.29333rem;margin-bottom:.34666rem;padding:.29333rem 0}.module-story .icon-list-cont .icon-item .left-cont[data-v-43060691]{width:1.38666rem;height:1.38666rem}.module-story .icon-list-cont .icon-item .right-cont[data-v-43060691]{text-algin:left}", "", {"version":3,"sources":["/Users/randy/kada-official-web/public/mobile/src/views/home/StoryDesc.vue"],"names":[],"mappings":"AACA,+BACE,mBAAoB,AACpB,kBAAmB,AACnB,4BAA+B,CAChC,AACD,4CACE,kBAAmB,AACnB,cAAe,AACf,iBAAmB,AACnB,eAAiB,CAClB,AACD,2CACE,kBAAmB,AACnB,kBAAoB,AACpB,cAAe,AACf,gBAAmB,CACpB,AACD,+CACE,qBAAuB,AACvB,oBAAqB,AACrB,qBAAsB,AACtB,aAAc,AACd,uBAAwB,AACxB,eAAgB,AAChB,8BAA+B,AAC/B,qCAAsC,AACtC,kCAAmC,AACnC,4BAA8B,CAC/B,AACD,0DACE,UAAW,AACX,wBAA0B,AAC1B,gBAAiB,AACjB,oBAAqB,AACrB,qBAAsB,AACtB,aAAc,AACd,yBAA0B,AAC1B,2BAA4B,AAC5B,wBAAyB,AACzB,mBAAoB,AACpB,WAAY,AACZ,oBAAsB,AACtB,wBAA0B,AAC1B,mBAAsB,CACvB,AACD,qEACE,iBAAkB,AAClB,iBAAmB,CACpB,AACD,sEACE,eAAiB,CAClB","file":"StoryDesc.vue","sourcesContent":["\n.module-story[data-v-43060691] {\n  background: #f6f8fb;\n  position: relative;\n  padding: 1.17333rem 0.42666rem;\n}\n.module-story .title-style[data-v-43060691] {\n  text-align: center;\n  color: #3f3f3f;\n  font-size: 0.48rem;\n  font-weight: 600;\n}\n.module-story .desc-style[data-v-43060691] {\n  text-align: center;\n  margin-top: 0.16rem;\n  color: #3f3f3f;\n  font-size: 0.32rem;\n}\n.module-story .icon-list-cont[data-v-43060691] {\n  margin-top: 0.53333rem;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: flex;\n  -webkit-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -webkit-box-pack: space-around;\n  -webkit-justify-content: space-around;\n  -moz-justify-content: space-around;\n  justify-content: space-around;\n}\n.module-story .icon-list-cont .icon-item[data-v-43060691] {\n  width: 48%;\n  border-radius: 0.53333rem;\n  background: #fff;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: flex;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n  -moz-align-items: center;\n  align-items: center;\n  color: #666;\n  font-size: 0.29333rem;\n  margin-bottom: 0.34666rem;\n  padding: 0.29333rem 0;\n}\n.module-story .icon-list-cont .icon-item .left-cont[data-v-43060691] {\n  width: 1.38666rem;\n  height: 1.38666rem;\n}\n.module-story .icon-list-cont .icon-item .right-cont[data-v-43060691] {\n  text-algin: left;\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ "OdqD":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(true);
// imports


// module
exports.push([module.i, ".module-features[data-v-3dabd3ad]{position:relative;overflow:hidden;margin-top:.34666rem;padding:.42666rem .42666rem .69333rem}.module-features .set-margin[data-v-3dabd3ad]{margin-top:.8rem}.module-features .title-cont h1[data-v-3dabd3ad]{text-align:center;font-size:.53333rem;font-weight:600;color:#3f3f3f;height:.74666rem;line-height:.74666rem;margin-bottom:.16rem}.module-features .title-cont p[data-v-3dabd3ad]{font-size:.29333rem;color:#666;line-height:.45333rem}.module-features img[data-v-3dabd3ad]{margin-top:.53333rem}", "", {"version":3,"sources":["/Users/randy/kada-official-web/public/mobile/src/views/home/BookAnServiceDesc.vue"],"names":[],"mappings":"AACA,kCACE,kBAAmB,AACnB,gBAAiB,AACjB,qBAAuB,AACvB,qCAA0C,CAC3C,AACD,8CACE,gBAAmB,CACpB,AACD,iDACE,kBAAmB,AACnB,oBAAsB,AACtB,gBAAiB,AACjB,cAAe,AACf,iBAAmB,AACnB,sBAAwB,AACxB,oBAAuB,CACxB,AACD,gDACE,oBAAsB,AACtB,WAAY,AACZ,qBAAwB,CACzB,AACD,sCACE,oBAAuB,CACxB","file":"BookAnServiceDesc.vue","sourcesContent":["\n.module-features[data-v-3dabd3ad] {\n  position: relative;\n  overflow: hidden;\n  margin-top: 0.34666rem;\n  padding: 0.42666rem 0.42666rem 0.69333rem;\n}\n.module-features .set-margin[data-v-3dabd3ad] {\n  margin-top: 0.8rem;\n}\n.module-features .title-cont h1[data-v-3dabd3ad] {\n  text-align: center;\n  font-size: 0.53333rem;\n  font-weight: 600;\n  color: #3f3f3f;\n  height: 0.74666rem;\n  line-height: 0.74666rem;\n  margin-bottom: 0.16rem;\n}\n.module-features .title-cont p[data-v-3dabd3ad] {\n  font-size: 0.29333rem;\n  color: #666;\n  line-height: 0.45333rem;\n}\n.module-features img[data-v-3dabd3ad] {\n  margin-top: 0.53333rem;\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ "Pm46":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(true);
// imports


// module
exports.push([module.i, ".module-system[data-v-799e61ee]{background:#f6f6f6;position:relative;overflow:hidden;padding-top:.66666rem}.module-system .set-margin[data-v-799e61ee]{margin-top:.8rem}.module-system .title-cont h1[data-v-799e61ee]{text-align:center;font-size:.53333rem;font-weight:600;color:#3f3f3f;height:.74666rem;line-height:.74666rem;margin-bottom:.45333rem}.module-system .title-cont p[data-v-799e61ee]{width:60%;text-align:center;margin:0 auto;font-size:.32rem;color:#fff;background:-webkit-linear-gradient(right,#ff943a,#ffa23d);background:linear-gradient(270deg,#ff943a,#ffa23d);line-height:.66666rem;border-radius:.69333rem;margin-bottom:.42666rem;font-weight:700}.module-system .title-cont img[data-v-799e61ee]{margin-top:.53333rem}", "", {"version":3,"sources":["/Users/randy/kada-official-web/public/mobile/src/views/home/BookReadingSymtem.vue"],"names":[],"mappings":"AACA,gCACE,mBAAoB,AACpB,kBAAmB,AACnB,gBAAiB,AACjB,qBAAwB,CACzB,AACD,4CACE,gBAAmB,CACpB,AACD,+CACE,kBAAmB,AACnB,oBAAsB,AACtB,gBAAiB,AACjB,cAAe,AACf,iBAAmB,AACnB,sBAAwB,AACxB,uBAA0B,CAC3B,AACD,8CACE,UAAW,AACX,kBAAmB,AACnB,cAAe,AACf,iBAAmB,AACnB,WAAY,AACZ,0DAAqE,AACrE,mDAA8D,AAC9D,sBAAwB,AACxB,wBAA0B,AAC1B,wBAA0B,AAC1B,eAAkB,CACnB,AACD,gDACE,oBAAuB,CACxB","file":"BookReadingSymtem.vue","sourcesContent":["\n.module-system[data-v-799e61ee] {\n  background: #f6f6f6;\n  position: relative;\n  overflow: hidden;\n  padding-top: 0.66666rem;\n}\n.module-system .set-margin[data-v-799e61ee] {\n  margin-top: 0.8rem;\n}\n.module-system .title-cont h1[data-v-799e61ee] {\n  text-align: center;\n  font-size: 0.53333rem;\n  font-weight: 600;\n  color: #3f3f3f;\n  height: 0.74666rem;\n  line-height: 0.74666rem;\n  margin-bottom: 0.45333rem;\n}\n.module-system .title-cont p[data-v-799e61ee] {\n  width: 60%;\n  text-align: center;\n  margin: 0 auto;\n  font-size: 0.32rem;\n  color: #fff;\n  background: -webkit-linear-gradient(right, #ff943a 0%, #ffa23d 100%);\n  background: linear-gradient(270deg, #ff943a 0%, #ffa23d 100%);\n  line-height: 0.66666rem;\n  border-radius: 0.69333rem;\n  margin-bottom: 0.42666rem;\n  font-weight: bold;\n}\n.module-system .title-cont img[data-v-799e61ee] {\n  margin-top: 0.53333rem;\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ "SFkb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__QRAndBg__ = __webpack_require__("pwRM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BookAnServiceDesc__ = __webpack_require__("L3Ll");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BookReadingSymtem__ = __webpack_require__("28OM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__BookNumberDesc__ = __webpack_require__("j71v");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CollectAndPartner__ = __webpack_require__("Vpbz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_m_connect_us_m_connect_us__ = __webpack_require__("aE28");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__BooksDesc_vue__ = __webpack_require__("7S72");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CourseDesc_vue__ = __webpack_require__("tTaF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__StoryDesc_vue__ = __webpack_require__("j0Mx");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// import AgeGrading from './AgeGrading'





/* harmony default export */ __webpack_exports__["a"] = ({
    name: "home",
    components: {
        QRAndBg: __WEBPACK_IMPORTED_MODULE_0__QRAndBg__["a" /* default */],
        BookAnServiceDesc: __WEBPACK_IMPORTED_MODULE_1__BookAnServiceDesc__["a" /* default */],
        BookNumberDesc: __WEBPACK_IMPORTED_MODULE_3__BookNumberDesc__["a" /* default */],
        // AgeGrading,
        CollectAndPartner: __WEBPACK_IMPORTED_MODULE_4__CollectAndPartner__["a" /* default */],
        ContactUs: __WEBPACK_IMPORTED_MODULE_5__components_m_connect_us_m_connect_us__["a" /* default */],
        BookReadingSymtem: __WEBPACK_IMPORTED_MODULE_2__BookReadingSymtem__["a" /* default */],
        BooksDesc: __WEBPACK_IMPORTED_MODULE_6__BooksDesc_vue__["a" /* default */],
        CourseDesc: __WEBPACK_IMPORTED_MODULE_7__CourseDesc_vue__["a" /* default */],
        StoryDesc: __WEBPACK_IMPORTED_MODULE_8__StoryDesc_vue__["a" /* default */]
    },
    created: function created() {
        window.scrollTo(0, 0);
        this.$sendBehavior('pv_204001');
    }
});

/***/ }),

/***/ "Vpbz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CollectAndPartner_vue__ = __webpack_require__("wGhq");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11b5351e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CollectAndPartner_vue__ = __webpack_require__("ZZe7");
function injectStyle (ssrContext) {
  __webpack_require__("Ci0F")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-11b5351e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CollectAndPartner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11b5351e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CollectAndPartner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "W3Lf":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(true);
// imports


// module
exports.push([module.i, ".module-books[data-v-628a16a4]{background:#fff;position:relative;padding:1.17333rem .42666rem}.module-books .text-cont[data-v-628a16a4]{text-align:center}.module-books .text-cont .title-style[data-v-628a16a4]{color:#3f3f3f;font-size:.48rem;font-weight:600}.module-books .text-cont .desc-style[data-v-628a16a4]{margin-top:.16rem;color:#3f3f3f;font-size:.32rem}.module-books .icon-list-cont[data-v-628a16a4]{margin:.53333rem 0;display:-webkit-box;display:-webkit-flex;display:flex;-webkit-flex-wrap:nowrap;flex-wrap:nowrap;-webkit-box-pack:space-around;-webkit-justify-content:space-around;-moz-justify-content:space-around;justify-content:space-around}.module-books .icon-list-cont .icon-item[data-v-628a16a4]{padding:.26666rem;background:#f6f8fb;border-radius:.42666rem}.module-books .icon-list-cont .icon-item img[data-v-628a16a4]{width:1.33333rem;height:1.33333rem;margin:0 auto}.module-books .icon-list-cont div[data-v-628a16a4]:nth-child(2){margin:0 .34666rem}.module-books .icon-list-cont .icon-desc[data-v-628a16a4]{text-align:center;color:#666;font-size:.26666rem}", "", {"version":3,"sources":["/Users/randy/kada-official-web/public/mobile/src/views/home/CourseDesc.vue"],"names":[],"mappings":"AACA,+BACE,gBAAiB,AACjB,kBAAmB,AACnB,4BAA+B,CAChC,AACD,0CACE,iBAAmB,CACpB,AACD,uDACE,cAAe,AACf,iBAAmB,AACnB,eAAiB,CAClB,AACD,sDACE,kBAAoB,AACpB,cAAe,AACf,gBAAmB,CACpB,AACD,+CACE,mBAAqB,AACrB,oBAAqB,AACrB,qBAAsB,AACtB,aAAc,AACd,yBAA0B,AAC1B,iBAAkB,AAClB,8BAA+B,AAC/B,qCAAsC,AACtC,kCAAmC,AACnC,4BAA8B,CAC/B,AACD,0DACE,kBAAoB,AACpB,mBAAoB,AACpB,uBAA0B,CAC3B,AACD,8DACE,iBAAkB,AAClB,kBAAmB,AACnB,aAAe,CAChB,AACD,gEACE,kBAAqB,CACtB,AACD,0DACE,kBAAmB,AACnB,WAAY,AACZ,mBAAsB,CACvB","file":"CourseDesc.vue","sourcesContent":["\n.module-books[data-v-628a16a4] {\n  background: #fff;\n  position: relative;\n  padding: 1.17333rem 0.42666rem;\n}\n.module-books .text-cont[data-v-628a16a4] {\n  text-align: center;\n}\n.module-books .text-cont .title-style[data-v-628a16a4] {\n  color: #3f3f3f;\n  font-size: 0.48rem;\n  font-weight: 600;\n}\n.module-books .text-cont .desc-style[data-v-628a16a4] {\n  margin-top: 0.16rem;\n  color: #3f3f3f;\n  font-size: 0.32rem;\n}\n.module-books .icon-list-cont[data-v-628a16a4] {\n  margin: 0.53333rem 0;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: flex;\n  -webkit-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n  -webkit-box-pack: space-around;\n  -webkit-justify-content: space-around;\n  -moz-justify-content: space-around;\n  justify-content: space-around;\n}\n.module-books .icon-list-cont .icon-item[data-v-628a16a4] {\n  padding: 0.26666rem;\n  background: #f6f8fb;\n  border-radius: 0.42666rem;\n}\n.module-books .icon-list-cont .icon-item img[data-v-628a16a4] {\n  width: 1.33333rem;\n  height: 1.33333rem;\n  margin: 0 auto;\n}\n.module-books .icon-list-cont div[data-v-628a16a4]:nth-child(2) {\n  margin: 0 0.34666rem;\n}\n.module-books .icon-list-cont .icon-desc[data-v-628a16a4] {\n  text-align: center;\n  color: #666;\n  font-size: 0.26666rem;\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ "Ykqc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            mobileImg: '//cdn.hhdd.com/frontend/as/i/75ff5fba-9de9-5acf-acad-ad17f07db683.png',
            iconList: [{
                imgUrl: 'https://cdn.hhdd.com/frontend/as/i/8ae156ce-da81-525f-b580-08ecdeaf0789.png',
                desc: '多元主题<br>覆盖儿童成长各方面'
            }, {
                imgUrl: 'https://cdn.hhdd.com/frontend/as/i/5e5b3d61-97b4-54fb-8039-608db3708593.png',
                desc: '科学分龄<br>定制专属阅读方案'
            }, {
                imgUrl: 'https://cdn.hhdd.com/frontend/as/i/f844f14c-9f80-5545-af3b-c2ac3d99fda5.png',
                desc: '智能有声<br>孩子轻松自主阅读'
            }]
        };
    }
});

/***/ }),

/***/ "Z2Id":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            mobileImg: '//cdn.hhdd.com/frontend/as/i/c557faab-4cb0-52dd-8b5a-946cdd23febf.png',
            iconList: [{
                imgUrl: 'https://cdn.hhdd.com/frontend/as/i/ea2874e2-2ff0-5bcd-8501-977fb4cb6330.png',
                firstLine: '从听到读',
                secondLine: '培养孩子阅读兴趣'
            }, {
                imgUrl: 'https://cdn.hhdd.com/frontend/as/i/65bb9198-c58c-50cd-b9c6-362f997e42f5.png',
                firstLine: '品质精选',
                secondLine: '专业评选经典听书'
            }, {
                imgUrl: 'https://cdn.hhdd.com/frontend/as/i/042807a7-fdc4-5bc8-b4eb-a0916c8fa349.png',
                firstLine: '各类听书',
                secondLine: '为儿童打造耳朵书房'
            }, {
                imgUrl: 'https://cdn.hhdd.com/frontend/as/i/9406aaab-17c4-59ef-8e4c-6919c6216f3a.png',
                firstLine: '专业演绎',
                secondLine: '轻松让孩子走进故事'
            }]
        };
    }
});

/***/ }),

/***/ "ZZe7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"module-cont module-harvest"},[_c('div',{staticClass:"section-partner"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"parttner-channel-list"},_vm._l((_vm.channelList),function(item,index){return _c('div',{key:index,class:{'parttner-channel-item':true,'not-first-item': index%4 !== 0 }},[_c('img',{attrs:{"src":item,"alt":""}})])}),0)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title-cont"},[_c('h1',[_c('span',{staticClass:"fzlty-zc"},[_vm._v("KaDa")]),_vm._v("阅读渠道合作方")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "aE28":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_m_connect_us_vue__ = __webpack_require__("Malx");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_97a290b2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_m_connect_us_vue__ = __webpack_require__("3Kq5");
function injectStyle (ssrContext) {
  __webpack_require__("K/qR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-97a290b2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_m_connect_us_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_97a290b2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_m_connect_us_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "aTeC":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(true);
// imports


// module
exports.push([module.i, ".module-books[data-v-56d73d1a]{background:#f6f8fb;position:relative;padding:1.17333rem .42666rem}.module-books .text-cont[data-v-56d73d1a]{text-align:center}.module-books .text-cont .title-style[data-v-56d73d1a]{font-size:.48rem;font-weight:600;color:#3f3f3f}.module-books .text-cont .desc-style[data-v-56d73d1a]{margin-top:.16rem;color:#3f3f3f;font-size:.32rem}.module-books .icon-list-cont[data-v-56d73d1a]{margin:.53333rem 0;display:-webkit-box;display:-webkit-flex;display:flex;-webkit-flex-wrap:nowrap;flex-wrap:nowrap;-webkit-box-pack:space-around;-webkit-justify-content:space-around;-moz-justify-content:space-around;justify-content:space-around}.module-books .icon-list-cont div[data-v-56d73d1a]:nth-child(2){margin:0 .34666rem}.module-books .icon-list-cont .icon-item[data-v-56d73d1a]{padding:.26666rem;background:#fff;border-radius:.42666rem;font-size:.26666rem}.module-books .icon-list-cont .icon-item img[data-v-56d73d1a]{width:1.33333rem;height:1.33333rem;margin:0 auto}.module-books .icon-list-cont .icon-desc[data-v-56d73d1a]{-webkit-box-flex:1;-webkit-flex:1;-moz-flex:1;flex:1;text-align:center;color:#666;font-size:.26666rem}", "", {"version":3,"sources":["/Users/randy/kada-official-web/public/mobile/src/views/home/BooksDesc.vue"],"names":[],"mappings":"AACA,+BACE,mBAAoB,AACpB,kBAAmB,AACnB,4BAA+B,CAChC,AACD,0CACE,iBAAmB,CACpB,AACD,uDAEE,iBAAmB,AACnB,gBAAiB,AACjB,aAAe,CAChB,AACD,sDACE,kBAAoB,AACpB,cAAe,AACf,gBAAmB,CACpB,AACD,+CACE,mBAAqB,AACrB,oBAAqB,AACrB,qBAAsB,AACtB,aAAc,AACd,yBAA0B,AAC1B,iBAAkB,AAClB,8BAA+B,AAC/B,qCAAsC,AACtC,kCAAmC,AACnC,4BAA8B,CAC/B,AACD,gEACE,kBAAqB,CACtB,AACD,0DACE,kBAAoB,AACpB,gBAAiB,AACjB,wBAA0B,AAC1B,mBAAsB,CACvB,AACD,8DACE,iBAAkB,AAClB,kBAAmB,AACnB,aAAe,CAChB,AACD,0DACE,mBAAoB,AACpB,eAAgB,AAChB,YAAa,AACb,OAAQ,AACR,kBAAmB,AACnB,WAAY,AACZ,mBAAsB,CACvB","file":"BooksDesc.vue","sourcesContent":["\n.module-books[data-v-56d73d1a] {\n  background: #f6f8fb;\n  position: relative;\n  padding: 1.17333rem 0.42666rem;\n}\n.module-books .text-cont[data-v-56d73d1a] {\n  text-align: center;\n}\n.module-books .text-cont .title-style[data-v-56d73d1a] {\n  color: #3f3f3f;\n  font-size: 0.48rem;\n  font-weight: 600;\n  color: #3f3f3f;\n}\n.module-books .text-cont .desc-style[data-v-56d73d1a] {\n  margin-top: 0.16rem;\n  color: #3f3f3f;\n  font-size: 0.32rem;\n}\n.module-books .icon-list-cont[data-v-56d73d1a] {\n  margin: 0.53333rem 0;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: flex;\n  -webkit-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n  -webkit-box-pack: space-around;\n  -webkit-justify-content: space-around;\n  -moz-justify-content: space-around;\n  justify-content: space-around;\n}\n.module-books .icon-list-cont div[data-v-56d73d1a]:nth-child(2) {\n  margin: 0 0.34666rem;\n}\n.module-books .icon-list-cont .icon-item[data-v-56d73d1a] {\n  padding: 0.26666rem;\n  background: #fff;\n  border-radius: 0.42666rem;\n  font-size: 0.26666rem;\n}\n.module-books .icon-list-cont .icon-item img[data-v-56d73d1a] {\n  width: 1.33333rem;\n  height: 1.33333rem;\n  margin: 0 auto;\n}\n.module-books .icon-list-cont .icon-desc[data-v-56d73d1a] {\n  -webkit-box-flex: 1;\n  -webkit-flex: 1;\n  -moz-flex: 1;\n  flex: 1;\n  text-align: center;\n  color: #666;\n  font-size: 0.26666rem;\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ "d1RO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view-content page-home"},[_c('QRAndBg'),_vm._v(" "),_c('BookAnServiceDesc'),_vm._v(" "),_c('BookReadingSymtem'),_vm._v(" "),_c('BookNumberDesc'),_vm._v(" "),_c('BooksDesc'),_vm._v(" "),_c('CourseDesc'),_vm._v(" "),_c('StoryDesc'),_vm._v(" "),_c('ContactUs',{attrs:{"whiteBg":false}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "dKxR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"module-cont module-system"},[_c('div',{staticClass:"title-cont"},[_c('h1',[_c('span',{staticClass:"fzlty-zc"},[_vm._v("KaDa")]),_vm._v("阅读体系")]),_vm._v(" "),_c('p',[_c('span',{staticClass:"fzlty-zc"},[_vm._v("KaDa")]),_vm._v("阅读·3-13岁少儿阅读解决方案")])]),_vm._v(" "),_c('img',{attrs:{"src":"//cdn.hhdd.com/frontend/as/i/5b48ad44-1b06-510d-a846-f1a174b2faf4.png","alt":""}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "eUvf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"module-cont module-books"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"icon-list-cont"},_vm._l((_vm.iconList),function(item,index){return _c('div',{key:index,staticClass:"icon-item"},[_c('img',{attrs:{"src":item.imgUrl,"alt":""}}),_vm._v(" "),_c('p',{staticClass:"icon-desc",domProps:{"innerHTML":_vm._s(item.desc)}})])}),0),_vm._v(" "),_c('img',{staticClass:"mobile-icon",attrs:{"src":_vm.mobileImg,"alt":""}})])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-cont"},[_c('div',{staticClass:"title-style"},[_c('span',{staticClass:"fzlty-zc"},[_vm._v("KaDa")]),_vm._v("互动阅读馆-AI轻课")]),_vm._v(" "),_c('div',{staticClass:"desc-style"},[_vm._v("15000+知识视频，引领孩子从泛读走向精读")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "f2c8":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("OdqD");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("4d10a398", content, true, {});

/***/ }),

/***/ "j0Mx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StoryDesc_vue__ = __webpack_require__("Z2Id");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43060691_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StoryDesc_vue__ = __webpack_require__("yA29");
function injectStyle (ssrContext) {
  __webpack_require__("EeHo")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-43060691"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StoryDesc_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43060691_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StoryDesc_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "j71v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BookNumberDesc_vue__ = __webpack_require__("83Cv");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3fee451e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BookNumberDesc_vue__ = __webpack_require__("DODS");
function injectStyle (ssrContext) {
  __webpack_require__("74q4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3fee451e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BookNumberDesc_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3fee451e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BookNumberDesc_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lOWy":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(true);
// imports


// module
exports.push([module.i, ".connect-us-cont[data-v-97a290b2]{padding-bottom:.21333rem;background:url(\"//cdn.hhdd.com/frontend/as/i/4845c6e4-848d-5911-9193-75ec18cce687.png\") no-repeat 50%;background-size:100% 100%;background-color:#fff;display:-webkit-box;display:-webkit-flex;display:flex;font-size:.32rem}.connect-us-cont .contact-copyright[data-v-97a290b2],.connect-us-cont .contact-us[data-v-97a290b2]{padding-top:.69333rem;padding-bottom:.26666rem}.connect-us-cont .contact-us[data-v-97a290b2]{padding-left:.32rem;line-height:.48rem}.connect-us-cont .contact-copyright[data-v-97a290b2]{padding-left:.8rem;line-height:.48rem}", "", {"version":3,"sources":["/Users/randy/kada-official-web/public/mobile/src/components/m-connect-us/m-connect-us.vue"],"names":[],"mappings":"AACA,kCACE,yBAA2B,AAC3B,sGAA0G,AAC1G,0BAA2B,AAC3B,sBAAuB,AACvB,oBAAqB,AACrB,qBAAsB,AACtB,aAAc,AACd,gBAAmB,CACpB,AACD,mGAEE,sBAAwB,AACxB,wBAA2B,CAC5B,AACD,8CACE,oBAAsB,AACtB,kBAAqB,CACtB,AACD,qDACE,mBAAqB,AACrB,kBAAqB,CACtB","file":"m-connect-us.vue","sourcesContent":["\n.connect-us-cont[data-v-97a290b2] {\n  padding-bottom: 0.21333rem;\n  background: url(\"//cdn.hhdd.com/frontend/as/i/4845c6e4-848d-5911-9193-75ec18cce687.png\") no-repeat center;\n  background-size: 100% 100%;\n  background-color: #fff;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: flex;\n  font-size: 0.32rem;\n}\n.connect-us-cont .contact-us[data-v-97a290b2],\n.connect-us-cont .contact-copyright[data-v-97a290b2] {\n  padding-top: 0.69333rem;\n  padding-bottom: 0.26666rem;\n}\n.connect-us-cont .contact-us[data-v-97a290b2] {\n  padding-left: 0.32rem;\n  line-height: 0.48rem;\n}\n.connect-us-cont .contact-copyright[data-v-97a290b2] {\n  padding-left: 0.8rem;\n  line-height: 0.48rem;\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ "oO6H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            starImg: '//cdn.hhdd.com/frontend/as/i/7a4940ed-e912-5d63-916e-5a980c6ac606.png',
            mobileImg: '//cdn.hhdd.com/frontend/as/i/899fec17-9110-53bd-980d-9d3f0d7ab3a0.png',
            kadaImg: '//cdn.hhdd.com/frontend/as/i/2ac042e6-0046-5af3-a72c-7d142103d869.png',
            iconList: [{
                imgUrl: 'https://cdn.hhdd.com/frontend/as/i/27a77028-376a-5396-8799-ab4d504e64b8.png',
                desc: 'Q版设计<br>增强学习代入感'
            }, {
                imgUrl: 'https://cdn.hhdd.com/frontend/as/i/5b5ac4c0-e555-515b-b92d-11267ba3e84d.png',
                desc: '童言童语<br>更易孩子理解吸收'
            }, {
                imgUrl: 'https://cdn.hhdd.com/frontend/as/i/7e9f2edf-2427-506b-9ee3-c4af0e62732f.png',
                desc: '多感官互动<br>充分激活孩子脑力'
            }]
        };
    }
});

/***/ }),

/***/ "pCi2":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("aTeC");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("c56fbffa", content, true, {});

/***/ }),

/***/ "pwRM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_QRAndBg_vue__ = __webpack_require__("MY0F");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bc232558_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_QRAndBg_vue__ = __webpack_require__("B5rl");
function injectStyle (ssrContext) {
  __webpack_require__("qU4I")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-bc232558"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_QRAndBg_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bc232558_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_QRAndBg_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qU4I":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("7DzZ");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("a0834f60", content, true, {});

/***/ }),

/***/ "rfg/":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("Pm46");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("77f89a6f", content, true, {});

/***/ }),

/***/ "tTaF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CourseDesc_vue__ = __webpack_require__("oO6H");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_628a16a4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CourseDesc_vue__ = __webpack_require__("eUvf");
function injectStyle (ssrContext) {
  __webpack_require__("Eq9c")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-628a16a4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CourseDesc_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_628a16a4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CourseDesc_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wGhq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    components: {},
    data: function data() {
        return {
            channelList: ['https://cdn.hhdd.com/frontend/as/i/16798cb4-d547-5395-9a5d-2cbffbd34f0e.png', // 天猫
            'https://cdn.hhdd.com/frontend/as/i/ecd6868f-f8ad-584d-a726-db39bc7fc91f.png', // 百度
            'https://cdn.hhdd.com/frontend/as/i/15fd2299-fa34-525b-aecd-6a63c75357c5.png', // jd
            'https://cdn.hhdd.com/frontend/as/i/412caca0-7d4f-56ac-878e-25674d5a8a0f.png', // qtFM
            'https://cdn.hhdd.com/frontend/as/i/4528a8a2-3401-5144-bf6c-7bf0a8328e1e.png', // 步步高
            'https://cdn.hhdd.com/frontend/as/i/18d6e04b-2e74-5b14-862f-78c63550025c.png', // 优学派
            'https://cdn.hhdd.com/frontend/as/i/92d020fe-ef09-5293-a4c3-1474d76dc8f0.png', // roobo
            'https://cdn.hhdd.com/frontend/as/i/de189c3b-4d5d-5979-b12f-1fd113f17853.png', // keeko
            'https://cdn.hhdd.com/frontend/as/i/96e56114-f151-598e-af35-3282a33c2c99.png', // 小天才
            'https://cdn.hhdd.com/frontend/as/i/3abc1b6d-0771-53e8-9b95-7b7d0ddc0fe8.png', // 科大讯飞
            'https://cdn.hhdd.com/frontend/as/i/9033aeef-ea2b-5c4b-82b6-d5aea260d33c.png', // 华为
            'https://cdn.hhdd.com/frontend/as/i/56835d0e-7c8a-563f-b463-4fa509762983.png']
        };
    }
});

/***/ }),

/***/ "yA29":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"module-cont module-story"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"icon-list-cont"},_vm._l((_vm.iconList),function(item,index){return _c('div',{key:index,staticClass:"icon-item"},[_c('img',{staticClass:"left-cont",attrs:{"src":item.imgUrl,"alt":""}}),_vm._v(" "),_c('div',{staticClass:"right-cont"},[_c('div',{staticClass:"first-line"},[_vm._v(_vm._s(item.firstLine))]),_vm._v(" "),_c('div',{staticClass:"second-line"},[_vm._v(_vm._s(item.secondLine))])])])}),0),_vm._v(" "),_c('img',{staticClass:"mobile-icon",attrs:{"src":_vm.mobileImg,"alt":""}})])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-cont"},[_c('div',{staticClass:"title-style"},[_c('span',{staticClass:"fzlty-zc"},[_vm._v("KaDa")]),_vm._v("有声阅读馆-听书")]),_vm._v(" "),_c('div',{staticClass:"desc-style"},[_vm._v("20000+趣味故事，让孩子从耳朵开始阅读")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zKIK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_home_vue__ = __webpack_require__("SFkb");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a26bffc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_home_vue__ = __webpack_require__("d1RO");
function injectStyle (ssrContext) {
  __webpack_require__("3FXf")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a26bffc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ })

});


// WEBPACK FOOTER //
// static/js/0.b685e87ee54f2f7caab4.js